<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>

        <template slot="photos" slot-scope="data">
            <b-button size="sm" v-if="!data.detailsShowing" :disabled="!data.item.safety_recommendation_photos.length" @click.stop="data.toggleDetails" variant="primary">Fotos <b-badge>{{ data.item.safety_recommendation_photos.length }}</b-badge></b-button>
            <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar</b-button>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="uploadPhotos(item)"><i class="fa fa-file-image-o" aria-hidden="true"></i></b-button>
            <b-button size="sm" variant="primary" @click="updateRecommendation(item)"><i class="fa fa-pencil"></i></b-button>
            <b-button size="sm" variant="danger" @click="removeRecommendation(item)"><i class="fa fa-trash"></i></b-button>
        </template>

        <template slot="row-details" slot-scope="data">
            <div class="d-flex justify-content-center">
                <div class="w-50">
                    <b-carousel id="carousel1"
                        style="text-shadow: 1px 1px 2px #333;"
                        controls
                        indicators
                        background="#ababab"
                        :interval="4000"
                        img-width="350px"
                        img-height="200px"
                    >
                        <b-carousel-slide v-for="photo in data.item.safety_recommendation_photos" img-height="200" :key="photo.id" :img-src="photo.photo_url"
                    ></b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: [
                    {
                        key: 'created_at',
                        label: 'Fecha creación',
                        filter: true
                    },
                    {
                        key: 'client.name',
                        label: 'Cliente',
                        filter: true
                    },
                    {
                        key: 'structure.name',
                        label: 'Estructura',
                        filter: true
                    },
                    {
                        key: 'user.name',
                        label: 'Creador',
                        filter: true
                    },
                    {
                        key: 'description',
                        label: 'Descripción',
                        filter: true
                    },
                    {
                        key: 'photos',
                        label: 'Fotos',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ],
                slide: 1
        }
    },
    computed: {
        tableData(){
            if(!this.data || !this.data.data) return [];

            return this.data.data.map(item => ({...item, client: item.structure.client}));
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateRecommendation(data){
            this.$emit('update-recommendation', data);
        },
        removeRecommendation(data){
            this.$emit('remove-recommendation', data);
        },
        uploadPhotos(data){
            this.$emit('upload-photos', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>